import { render, staticRenderFns } from "./fenleiband.vue?vue&type=template&id=3a89fc8c&scoped=true"
import script from "./fenleiband.vue?vue&type=script&lang=js"
export * from "./fenleiband.vue?vue&type=script&lang=js"
import style0 from "./fenleiband.vue?vue&type=style&index=0&id=3a89fc8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89fc8c",
  null
  
)

export default component.exports